import { Footer } from '../types/footer';

export const FOOTER: Footer[] = [
    { text: 'Impressum', route: '/utility/impressum' },
    { text: 'Datenschutz', route: '/utility/data-protection' },
    { text: 'Pricing', route: '/utility/pricing' }
];
